export const environment = {
  production: true,
  baseApiUrl: 'https://webapi-devqa.cinico.ky',
  docuSignApiUrl: 'https://webapi-staging.cinico.ky/docusign/envelopes',
  urlPayment: 'https://pay1.plugnpay.com/pay/',
  urlSuccessAPI: 'https://myportal-devqa.cinico.ky/payments',
  motorPolicyUrlSuccessAPI: 'https://myportal-devqa.cinico.ky/quotes/create-quote/motor-quote',
  homePolicyUrlSuccessAPI: 'https://myportal-devqa.cinico.ky/quotes/create-quote/home-quote',
  publisherName: 'demoairvu',
  firebaseConfig: {
    apiKey: 'AIzaSyB-Le_4fEOp3vOG_nLWZh6f4w__lq0RG8g',
    authDomain: 'cinico-staging-1.firebaseapp.com',
    projectId: 'cinico-staging-1',
    storageBucket: 'cinico-staging-1.appspot.com',
    messagingSenderId: '1063422911730',
    appId: '1:1063422911730:web:654f891d39adaaa3f85c6b',
    measurementId: 'G-TDG2BMQ30J'
  }
};
